require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-strandpost-dishoek.json") })
        }
      }, "path---projecten-strandpost-dishoek");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-strandpost-dishoek!./.cache/json/projecten-strandpost-dishoek.json
// module id = 447
// module chunks = 231608221292675